import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../services/apiServices";

// Fetch POS products (using items API for now, focused on sellable items)
export const fetchPosProducts = createAsyncThunk(
    "pos/fetchPosProducts",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiServices.get("items"); // Or a specific POS products endpoint if available
            // Filter for items that are sellable if needed, or backend handles it
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error fetching products");
        }
    }
);

// Delete POS product
export const deletePosProduct = createAsyncThunk(
    "pos/deletePosProduct",
    async (id, { rejectWithValue }) => {
        try {
            await apiServices.delete(`items/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error deleting product");
        }
    }
);

const posSlice = createSlice({
    name: "pos",
    initialState: {
        products: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPosProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPosProducts.fulfilled, (state, action) => {
                state.loading = false;
                // Handle if response is paginated { data: [], total: ... }
                if (action.payload.data) {
                    state.products = action.payload.data;
                } else {
                    state.products = action.payload; // Assume direct array
                }
            })
            .addCase(fetchPosProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deletePosProduct.fulfilled, (state, action) => {
                state.products = state.products.filter((p) => p._id !== action.payload);
            });
    },
});

export default posSlice.reducer;
